// extracted by mini-css-extract-plugin
module.exports = {"p1gsts5b":"p1gsts5b"};